// API configuration for sync.direct backend

const getApiUrl = (): string => {
  // Check environment variable first
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }

  // Auto-detect based on current URL
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // Production domains
    if (hostname.includes('gamedate.co.il') || hostname.includes('sync.direct')) {
      return 'https://sync.direct';
    }
  }

  // Default to localhost for development
  return 'http://localhost:5049';
};

export const apiConfig = {
  baseUrl: getApiUrl(),
  endpoints: {
    auth: {
      signIn: '/api/auth/signin',
      signUp: '/api/auth/signup',
      signOut: '/api/auth/signout',
      refresh: '/api/auth/refresh',
    },
    player: {
      profile: '/api/player/profile',
      character: '/api/player/character',
    },
    rooms: {
      list: '/api/rooms',
      create: '/api/rooms/create',
      join: '/api/rooms/join',
    },
  },
  signalR: {
    hubUrl: `${getApiUrl()}/roomHub`,
  },
};

export default apiConfig;
